export default function NotFound() {
  return (
    <>
     <title>Not Found </title>
      <meta name="description" content="Browse professional courses to upskill yourself in technology, business, and more." />
      <meta name="keywords" content="courses, learning, edc, education, skills" />
      <meta property="og:title" content="Courses - EDC Learning" />
      <meta property="og:description" content="Find the right course to upskill yourself." />
      <meta property="og:image" content="/images/LSClogo.png" />
      <meta property="og:url" content="https://edc.lsc-india.org/" />
      <meta name="twitter:card" content="summary_large_image" />

    
    <div className="flex flex-col items-center justify-center text-center mt-16">
      <img src="/images/404.jpg" alt="404 Not Found" className="w-80 mb-4" />
      <h1 className="text-2xl font-bold">Oops! Page not found.</h1>
      <p className="text-gray-600 mt-2">The page you are looking for doesn’t exist.</p>
    </div>
    </>
  );
}